import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'neutral';
  size?: 'sm' | 'md';
}
export function Badge({
  children,
  variant = 'neutral',
  size = 'md'
}: BadgeProps) {
  const variantStyles = {
    primary: 'bg-dark-green text-white',
    secondary: 'bg-light-green text-dark-green',
    success: 'bg-light-green text-dark-green',
    warning: 'bg-clay text-white',
    neutral: 'bg-sand text-charcoal'
  };
  const sizeStyles = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm'
  };
  return <span className={`inline-flex items-center rounded-full font-medium ${variantStyles[variant]} ${sizeStyles[size]}`} data-id="element-134">
      {children}
    </span>;
}